export interface DescriptionObject {
  title: string;
  points: string[];
}

export const companyDescription: DescriptionObject[] = [
  {
    title: 'About itD:',
    points: [
      `We are part of a new generation of consulting and software development company that
      blends diversity, innovation, and integrity with real business results. Our structure
      rejects any strong hierarchy, empowering us to deliver excellent results. We are a
      woman- and minority-led firm. Every day, we challenge ourselves to be considerate, fair
      and to re-think what great outcomes mean for our customers. This permeates down to
      how we approach every interaction, on every project, for every client. You’ll thrive here if
      you are a dynamic self-starter, a difference-maker or someone who wants to deliver
      great results, without constraints.`,
    ],
  },
  {
    title: 'The itD Digital Experience:',
    points: [
      `Joining us means you’ll be part of our global community, you have a say about your own
      career journey, and you’ll get a chance to give back to causes that matter. You will
      experience working with Fortune 500 companies and high-performance teams across
      numerous industries.
      itD offers our employees excellent benefits such as medical, dental, vision, life
      insurance, paid holidays, 401K + matching, networking & career learning and
      development programs. We are growing and we want to see you grow!
      Visit https://itdtech.com/careers to learn more about what working at itD can mean
      for you.
      All qualified applicants will receive consideration for employment without regard to race,
      color, religion, sex, sexual orientation, gender identity, national origin, age, disability or
      protected veteran status, or any other legally protected basis, in accordance with
      applicable law.
      itD is committed to working with and providing reasonable accommodation to individuals
      with disabilities. If, because of a medical condition or disability, you need a reasonable
      accommodation for any part of the application process, or to perform the essential
      functions of a position, please contact us at recruiting@itdtech.com and let us know the
      nature of your request and your contact information.`,
    ],
  },
  {
    title: 'Additional Info:',
    points: [
      `Dynamic environment in a culture of respect, empowerment and recognition for a job
      well done, apply today!`,
    ],
  },
];

export const jobDescription: DescriptionObject[] = [
  {
    title: 'The internal responsibilities will be as follows:',
    points: [
      'Attend regular internal practice community meetings.',
      'Collaborate with your itD practice team on industry thought leadership.',
      'Complete client case studies and learning material. (Blogs, media material).',
      'Build out material to contribute to Digital Transformation practice.',
      'Attend internal itD networking events (in person and virtual).',
      ' Work with leadership on career fast-track opportunities.',
    ],
  },
];
